module.exports = __webpack_public_path__ + "img/Sergio-Balsa.d7986e26.jpg";